var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog",
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.visible,
        width: "600px",
        "close-on-click-modal": false,
      },
      on: { close: _setup.handleClose },
    },
    [
      _c(
        "div",
        { staticClass: "dialog-content" },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _setup.localFormData,
                rules: _setup.formRules,
                "label-width": "120px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "客服类型名称", prop: "type_name" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入客服类型名称",
                      maxlength: "50",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _setup.localFormData.type_name,
                      callback: function ($$v) {
                        _vm.$set(_setup.localFormData, "type_name", $$v)
                      },
                      expression: "localFormData.type_name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _setup.handleClose } }, [
            _vm._v("取消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _setup.loading },
              on: { click: _setup.handleConfirm },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }